import { User } from '../models/user.model';

export class AdminUserFactory {

  public static formatUsersForTable(userRecords, canViewCompanies): Array<any> {
    let headings: Array<any> = [
      { data: 'Name' },
      { data: 'Role' }
    ];

    if(canViewCompanies) {
      headings.push({data: 'Company'});
    }

    let formattedUserRecords = [];

    userRecords.forEach((record: User) => {
      let formattedHistoryRecord = [];

      formattedHistoryRecord.push({
          data: record.name
        });

      formattedHistoryRecord.push({
        data: record.roleName
      });

      if(canViewCompanies) {
        formattedHistoryRecord.push({
          data: record.companyName
        });
      }

      formattedUserRecords.push(formattedHistoryRecord)
    });

    return [headings, formattedUserRecords];
  }

}